var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { isLoading: _vm.saveLoading } }),
      _c(
        "Upload",
        {
          staticStyle: { display: "none" },
          attrs: {
            action: _vm.uploadImgUrl,
            format: ["pdf"],
            accept: ".pdf",
            "on-format-error": _vm.uploadError,
            data: _vm.uploadData,
            "max-size": _vm.maxImgSize,
            "on-exceeded-size": _vm.checkImgSize,
            "on-success": _vm.quillImgSuccess,
            "on-error": _vm.quillImagError,
            "show-upload-list": false,
            "before-upload": _vm.quillImgBefore,
          },
        },
        [
          _c("Button", {
            ref: "imgUploadPdfBtn",
            staticStyle: { display: "none" },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("quill-editor", {
            ref: _vm.toref,
            staticClass: "editor",
            style: { height: _vm.qillHeight + "px" },
            attrs: { options: _vm.editorOption },
            on: {
              blur: function ($event) {
                return _vm.onEditorBlur($event)
              },
              focus: function ($event) {
                return _vm.onEditorFocus($event)
              },
              change: function ($event) {
                return _vm.onEditorChange($event)
              },
            },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          }),
        ],
        1
      ),
      _c(
        "Button",
        {
          ref: "UploadPdfBtn",
          staticStyle: { display: "none" },
          attrs: { type: "primary" },
          on: { click: _vm.showPdfModel },
        },
        [_vm._v("上传pdf")]
      ),
      _c(
        "Modal",
        {
          attrs: { title: "上传Pdf" },
          model: {
            value: _vm.addPdfmodal,
            callback: function ($$v) {
              _vm.addPdfmodal = $$v
            },
            expression: "addPdfmodal",
          },
        },
        [
          _c("label", [_vm._v("pdf名称")]),
          _c("br"),
          _c("Input", {
            attrs: { placeholder: "请输入pdf名称..." },
            model: {
              value: _vm.pdfFormName,
              callback: function ($$v) {
                _vm.pdfFormName = $$v
              },
              expression: "pdfFormName",
            },
          }),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c("button", { on: { click: _vm.uploadPdf } }, [_vm._v("上传")]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }